
import { Card, CardContent } from "@/components/ui/card";
import { Client } from "../types";
import { EnrichmentStatusBanner } from "./info-sections/EnrichmentStatusBanner";
import { CompanyOverviewHeader } from "./info-sections/CompanyOverviewHeader";
import { CompanySummarySection } from "./info-sections/CompanySummarySection";
import { CoreInformationSection } from "./info-sections/CoreInformationSection";
import { KeyMetricsStatusSection } from "./info-sections/KeyMetricsStatusSection";
import { SocialMediaTechnologySection } from "./info-sections/SocialMediaTechnologySection";
import { InternalNotesSection } from "./info-sections/InternalNotesSection";
import { EnrichmentResponse } from '@/hooks/useCompanyEnrichment';

interface ClientInfoProps {
  client: Client;
  fieldsWithNewData?: Set<keyof Client>;
  handleEnrichClient?: () => void;
  isEnrichmentTriggering?: boolean;
  isEnrichmentPolling?: boolean;
  lastEnrichmentData?: Partial<EnrichmentResponse> | null;
}

export const ClientInfo = ({ 
  client, 
  fieldsWithNewData = new Set(),
  handleEnrichClient,
  isEnrichmentTriggering,
  isEnrichmentPolling,
  lastEnrichmentData,
}: ClientInfoProps) => {
  const currentProgressStage = lastEnrichmentData?.progress_stage || 
                               (client.enrichment_status === 'pending' || client.enrichment_status === 'processing' ? client.enrichment_status : undefined);
  const estimatedCompletionTime = lastEnrichmentData?.estimated_completion_at;
  const canViewResults = client.enrichment_status === 'available' || currentProgressStage === 'completed';

  return (
    <>
      <EnrichmentStatusBanner 
        client={client} 
        onEnrich={handleEnrichClient || (() => {})}
        isEnriching={isEnrichmentTriggering || false}
        isPolling={isEnrichmentPolling}
        lastEnrichmentProgressStage={currentProgressStage}
        estimatedCompletionTime={estimatedCompletionTime}
        onViewResults={canViewResults && handleEnrichClient ? handleEnrichClient : undefined}
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-3">
          <Card>
            <CompanyOverviewHeader client={client} fieldsWithNewData={fieldsWithNewData} />
            <CardContent className="space-y-6">
              <CompanySummarySection client={client} fieldsWithNewData={fieldsWithNewData} />
              <CoreInformationSection
                client={client}
                fieldsWithNewData={fieldsWithNewData}
              />
              <KeyMetricsStatusSection
                client={client}
                fieldsWithNewData={fieldsWithNewData}
              />
              <SocialMediaTechnologySection
                client={client}
                fieldsWithNewData={fieldsWithNewData}
              />
              <InternalNotesSection client={client} />
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};
